<template>
	<div>
		<h3 class="popup-tilte">Figyelmeztetés!</h3>
		<div class="fs-desc popup-content-width">
			200 000 Ft feletti érték esetén az "Értéktárgy kiegészítő biztosítás"-t automatikusan aktiváljuk az Ön
			számára.
		</div>

		<div class="popup-form form">
			<div class="d-flex mt-23px">
				<button type="button" class="btn btn-blue m-auto mt-30px" @click="handleAccept">Rendben</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
	methods: {
		...mapMutations(['showPopup', 'setEvent']),
		handleAccept() {
			this.setEvent({ id: 22 });
			this.showPopup(null);
		},
	},
};
</script>
